import { render, staticRenderFns } from "./MessageBody.vue?vue&type=template&id=6a40d13e&"
import script from "./MessageBody.vue?vue&type=script&lang=js&"
export * from "./MessageBody.vue?vue&type=script&lang=js&"
import style0 from "./MessageBody.vue?vue&type=style&index=0&id=6a40d13e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports